import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export function useInbox(page = 1) {
    return useQuery({
        queryKey: ['inbox', page],
        queryFn: async () => {
            const response = await axios.get('/api/messaging/inbox/', {
                params: { page },
                withCredentials: true,
            });
            return response.data;
        },
        staleTime: 30000, // 30 seconds
    });
}

export function useLoadMoreInbox() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (page) => {
            const response = await axios.get('/api/messaging/inbox/', {
                params: { page },
                withCredentials: true,
            });
            return response.data;
        },
        onSuccess: (newData, page) => {
            // Update the cache with the new page data
            queryClient.setQueryData(['inbox', page], newData);
        },
    });
}

export function useUnreadCount() {
    return useQuery({
        queryKey: ['inbox', 'unread_count'],
        queryFn: async () => {
            const response = await axios.get('/api/messaging/inbox/unread_count/', {
                withCredentials: true,
            });
            return response.data;
        },
        staleTime: 10000, // 10 seconds - more frequent updates for badge
    });
}

export function useMarkAsRead() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (messageId) => {
            const response = await axios.patch(`/api/messaging/inbox/${messageId}/read/`, {}, {
                withCredentials: true,
            });
            return response.data;
        },
        onSuccess: () => {
            // Invalidate all inbox queries since we have paginated data
            queryClient.invalidateQueries({ queryKey: ['inbox'] });
            queryClient.invalidateQueries({ queryKey: ['inbox', 'unread_count'] });
        },
    });
}

export function useDeleteMessage() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (messageId) => {
            const response = await axios.delete(`/api/messaging/inbox/${messageId}/delete_message/`, {
                withCredentials: true,
            });
            return response.data;
        },
        onSuccess: () => {
            // Invalidate all inbox queries since we have paginated data
            queryClient.invalidateQueries({ queryKey: ['inbox'] });
            queryClient.invalidateQueries({ queryKey: ['inbox', 'unread_count'] });
        },
    });
}

export function useMarkAllAsRead() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const response = await axios.post('/api/messaging/inbox/bulk_read/', {}, {
                withCredentials: true,
            });
            return response.data;
        },
        onSuccess: () => {
            // Invalidate all inbox queries since we have paginated data
            queryClient.invalidateQueries({ queryKey: ['inbox'] });
            queryClient.invalidateQueries({ queryKey: ['inbox', 'unread_count'] });
        },
    });
} 